var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useCallback, useEffect, useState } from "react";
import { enviarAgendamento, getConfig, getDoador, getNews, getPages, getStock, getSugestaoAgendamento, obterAgendamentoAnterior, cancelarAgendamentoWithApi, } from "../../apis/api";
import { useNavigate } from "react-router-dom";
import { Home } from "./Home";
import { estoques, formatarData, toSlug } from "../../util/theme";
import { useWebgate } from "@xvia/webgate-connect";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import axios from "axios";
export const HomeContainer = () => {
    const userInfo = useWebgate();
    const [config, setConfig] = useState();
    const [estoque, setEstoque] = useState(estoques);
    const [pages, setPages] = useState([]);
    const [botoes, setBotoes] = useState([]);
    const [noticias, setNoticias] = useState([]);
    const [doador, setDoador] = useState();
    const [agendamentoSugestao, setAgendamentoSugestao] = useState();
    const [agendamento, setAgendamento] = useState();
    const [data_atualizacao, setData_atualizacao] = useState();
    const [isLoadingAgendamento, setIsLoadingAgendamento] = useState(false);
    const navigate = useNavigate();
    const fetchConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getConfig();
        setConfig(response);
    }), []);
    const fetchPages = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getPages();
        setPages(response);
    }), []);
    const fetchNews = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getNews();
        setNoticias(response);
    }), []);
    const fecthDoador = useCallback((cpf) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getDoador(cpf);
        setDoador(response || {});
    }), []);
    const fecthAgendamentoAnterior = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield obterAgendamentoAnterior(userInfo.accessToken, "doacao-de-sangue");
        setAgendamento(response.data[0]);
    }), [userInfo]);
    const fecthSugestaoAgendamento = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!userInfo)
            return;
        let data = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo) === null || _a === void 0 ? void 0 : _a.dataNascimento;
        if (!!data)
            data = dayjs(data).format("DD/MM/YYYY");
        const response = yield getSugestaoAgendamento(userInfo === null || userInfo === void 0 ? void 0 : userInfo.accessToken, data, (_c = (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo) === null || _b === void 0 ? void 0 : _b.cep) === null || _c === void 0 ? void 0 : _c.replace("-", ""));
        setAgendamentoSugestao(response);
    }), [userInfo]);
    const salvarAgendamento = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e;
        if (!userInfo)
            return;
        setIsLoadingAgendamento(true);
        try {
            const response = yield enviarAgendamento(userInfo.accessToken, userInfo.userInfo.cpf, agendamentoSugestao.data, agendamentoSugestao.hora, agendamentoSugestao.unidade.id);
            if (response.detail) {
                const agendamentoData = JSON.parse(response.detail).data;
                setAgendamento(agendamentoData);
                toast.success("Agendamento realizado com sucesso!");
            }
            else {
                yield fecthAgendamentoAnterior();
                toast.success("Agendamento realizado com sucesso!");
            }
        }
        catch (error) {
            if (((_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.detail) ===
                "Já existe um agendamento ativo para este serviço") {
                toast.error("Já existe um agendamento ativo para este serviço");
                try {
                    const agendamentoExistente = yield obterAgendamentoAnterior(userInfo.accessToken, "doacao-de-sangue");
                    if (agendamentoExistente.data &&
                        agendamentoExistente.data.length > 0) {
                        setAgendamento(agendamentoExistente.data[0]);
                    }
                }
                catch (buscaError) {
                    console.error("Erro ao buscar agendamento existente:", buscaError);
                }
            }
            else {
                toast.error("Erro ao realizar agendamento. Tente novamente.");
            }
            console.error(error);
        }
        finally {
            setIsLoadingAgendamento(false);
        }
    }), [userInfo, agendamentoSugestao, fecthAgendamentoAnterior]);
    const cancelarAgendamentoHandler = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!userInfo || !agendamento)
            return;
        try {
            const api = axios.create({
                baseURL: process.env.AGENDAMENTO_URL || process.env.PORTAL_URL,
                headers: { Authorization: `Bearer ${userInfo.accessToken}` },
            });
            yield cancelarAgendamentoWithApi(api, agendamento.id);
            try {
                const agendamentoVerificado = yield obterAgendamentoAnterior(userInfo.accessToken, "doacao-de-sangue");
                if (agendamentoVerificado.data &&
                    agendamentoVerificado.data.length > 0) {
                    toast.error("Não foi possível cancelar o agendamento. Tente novamente.");
                    setAgendamento(agendamentoVerificado.data[0]);
                }
                else {
                    toast.success("Agendamento cancelado com sucesso!");
                    setAgendamento(null);
                    fecthAgendamentoAnterior();
                }
            }
            catch (verificacaoError) {
                toast.success("Agendamento cancelado com sucesso!");
                setAgendamento(null);
                fecthAgendamentoAnterior();
            }
        }
        catch (error) {
            toast.error("Erro ao cancelar agendamento.");
            console.error(error);
        }
    }), [userInfo, agendamento, fecthAgendamentoAnterior]);
    const fetchStock = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!config)
            return;
        const response = yield getStock();
        // Usa o primeiro estoque (Vitória por padrão)
        const estoqueVitória = response[0];
        if (!estoqueVitória)
            return;
        const max = config.valor_maximo || 100;
        const getLevel = (qtd) => (qtd * 100) / max;
        const estoques = [
            {
                tipo: "a_negativo",
                label: "A-",
                level: getLevel(estoqueVitória.a_negativo),
                quantidade: estoqueVitória.a_negativo,
            },
            {
                tipo: "a_positivo",
                label: "A+",
                level: getLevel(estoqueVitória.a_positivo),
                quantidade: estoqueVitória.a_positivo,
            },
            {
                tipo: "ab_negativo",
                label: "AB-",
                level: getLevel(estoqueVitória.ab_negativo),
                quantidade: estoqueVitória.ab_negativo,
            },
            {
                tipo: "b_negativo",
                label: "B-",
                level: getLevel(estoqueVitória.b_negativo),
                quantidade: estoqueVitória.b_negativo,
            },
            {
                tipo: "b_positivo",
                label: "B+",
                level: getLevel(estoqueVitória.b_positivo),
                quantidade: estoqueVitória.b_positivo,
            },
            {
                tipo: "ab_positivo",
                label: "AB+",
                level: getLevel(estoqueVitória.ab_positivo),
                quantidade: estoqueVitória.ab_positivo,
            },
            {
                tipo: "o_negativo",
                label: "O-",
                level: getLevel(estoqueVitória.o_negativo),
                quantidade: estoqueVitória.o_negativo,
            },
            {
                tipo: "o_positivo",
                label: "O+",
                level: getLevel(estoqueVitória.o_positivo),
                quantidade: estoqueVitória.o_positivo,
            },
        ];
        setEstoque(estoques);
        setData_atualizacao(formatarData(estoqueVitória.date_updated));
    }), [config]);
    useEffect(() => {
        var _a, _b;
        if ((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo) === null || _a === void 0 ? void 0 : _a.preferred_username) {
            fecthDoador((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo) === null || _b === void 0 ? void 0 : _b.preferred_username);
            fecthSugestaoAgendamento();
            fecthAgendamentoAnterior();
        }
    }, [
        userInfo,
        fecthSugestaoAgendamento,
        fecthDoador,
        fecthAgendamentoAnterior,
    ]);
    useEffect(() => {
        if (doador && !(doador === null || doador === void 0 ? void 0 : doador.doacao)) {
            doador.mensagem = `Olá ${userInfo.userInfo.name}, você ainda não possui doações registradas, estamos com os estóques baixos, achei um horário e um local próximo com base no seu perfil, podemos agendar?`;
            doador.nomeCompleto = userInfo.userInfo.name;
            setDoador(doador);
        }
        if ((doador === null || doador === void 0 ? void 0 : doador.doacao) && (doador === null || doador === void 0 ? void 0 : doador.doacao.length) >= 1) {
            doador.mensagem = `Olá ${userInfo.userInfo.name}, parabéns, você já doou sangue ${doador === null || doador === void 0 ? void 0 : doador.doacao.length} vezes, achei um horário e um local próximo com base no seu perfil, podemos agendar?`;
            doador.nomeCompleto = userInfo.userInfo.name;
            setDoador(doador);
        }
        if ((doador === null || doador === void 0 ? void 0 : doador.doacao) && agendamento) {
            doador.mensagem = `Olá ${userInfo.userInfo.name}, não se esqueça de sua doação agendada.`;
            doador.nomeCompleto = userInfo.userInfo.name;
            setDoador(doador);
        }
    }, [doador, userInfo, agendamento]);
    useEffect(() => {
        if (!agendamento)
            return;
        const doador = {};
        doador.mensagem = `Parabéns!! Sua doacão está confirmada, são se esqueca a data e o horário, ${dayjs(agendamento.agendado).format("DD/MM/YYYY HH:MM")}`;
        doador.doacao = [{}];
        setDoador(doador);
    }, [agendamento]);
    const navegatePage = useCallback((page) => {
        navigate("/" + toSlug(page.Titulo));
    }, [navigate]);
    const navegateNews = useCallback((news) => {
        navigate("/noticia/" + toSlug(news.slug));
    }, [navigate]);
    useEffect(() => {
        if (!config)
            fetchConfig();
        fetchStock();
        if (!pages.length)
            fetchPages();
        if (!noticias.length)
            fetchNews();
        if (config && pages.length) {
            setBotoes(pages
                .filter((page) => { var _a; return (_a = config.botoes) === null || _a === void 0 ? void 0 : _a.some((bt) => bt.Paginas_id === page.id); })
                .map((page) => ({
                label: page.Titulo,
                icon: page.Icone,
                subtitle: page.subtitulo,
                onClick: () => navegatePage(page),
            })));
        }
    }, [
        config,
        estoque.length,
        pages,
        noticias.length,
        fetchConfig,
        fetchStock,
        fetchPages,
        fetchNews,
        navegatePage,
    ]);
    return createElement(Home, {
        config,
        estoque,
        botoes,
        noticias,
        data_atualizacao,
        doador,
        pages,
        navegatePage,
        agendamentoSugestao,
        salvarAgendamento,
        agendamento,
        navegateNews,
        cancelarAgendamentoHandler,
        isLoadingAgendamento,
    });
};
